import { HOTELS } from '../data.js';

// Per-photo dwell time in milliseconds.
const STORY_DURATION = 4500;
const VIEWED_KEY = 'houruse:viewed-stories:v1';

let viewed = new Set();
let cur = { hotel: -1, pic: 0 };
let advanceTimer = null;
let onBookHandler = () => {};
let bound = false;

function loadViewed() {
  try {
    const raw = localStorage.getItem(VIEWED_KEY);
    if (raw) viewed = new Set(JSON.parse(raw));
  } catch {
    /* ignore */
  }
}

function saveViewed() {
  try {
    localStorage.setItem(VIEWED_KEY, JSON.stringify([...viewed]));
  } catch {
    /* ignore */
  }
}

// Featured = 4★ and up, in declaration order. Each item carries its
// HOTELS-array index alongside the source data so the viewer can
// hand off to the booking flow.
export function getFeatured() {
  return HOTELS.map((h, idx) => ({ ...h, idx })).filter((h) => h.st >= 4);
}

function $(id) {
  return document.getElementById(id);
}

function isOpen() {
  return $('storyViewer')?.classList.contains('show');
}

export function buildStoriesRail({ onBook }) {
  loadViewed();
  onBookHandler = onBook;

  const rail = $('storiesRail');
  if (!rail) return;

  const featured = getFeatured();
  rail.innerHTML = featured
    .map(
      (h, k) => `<button class="story-bubble${viewed.has(h.idx) ? ' viewed' : ''}" data-story="${k}" aria-label="${h.nm}">
        <span class="story-ring">
          <span class="story-ring-gap">
            <img src="${h.pics[0]}" alt="" loading="lazy" decoding="async" />
          </span>
        </span>
        <span class="story-name">${h.nm}</span>
      </button>`,
    )
    .join('');

  if (bound) return;
  bound = true;

  rail.addEventListener('click', (e) => {
    const b = e.target.closest('[data-story]');
    if (b) openViewer(+b.dataset.story);
  });

  $('svClose').addEventListener('click', closeViewer);
  $('svPrev').addEventListener('click', prevStory);
  $('svNext').addEventListener('click', nextStory);
  $('svBook').addEventListener('click', () => {
    const f = getFeatured();
    const h = f[cur.hotel];
    if (!h) return;
    closeViewer();
    onBookHandler(h.idx);
  });

  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') closeViewer();
    else if (e.key === 'ArrowLeft') prevStory();
    else if (e.key === 'ArrowRight') nextStory();
  });
}

function openViewer(featuredIdx) {
  cur.hotel = featuredIdx;
  cur.pic = 0;
  $('storyViewer').classList.add('show');
  renderStory();
}

function closeViewer() {
  clearTimeout(advanceTimer);
  $('storyViewer').classList.remove('show');
  cur.hotel = -1;
  cur.pic = 0;
}

function renderStory() {
  const featured = getFeatured();
  const h = featured[cur.hotel];
  if (!h) return closeViewer();

  // Mark hotel as viewed once the first photo renders.
  if (!viewed.has(h.idx)) {
    viewed.add(h.idx);
    saveViewed();
    document
      .querySelectorAll(`.story-bubble[data-story="${cur.hotel}"]`)
      .forEach((b) => b.classList.add('viewed'));
  }

  const img = $('svImg');
  img.src = h.pics[cur.pic];

  $('svName').textContent = h.nm;
  $('svSub').textContent = `${h.city} · ${'★'.repeat(h.st)}`;

  const progress = $('svProgress');
  progress.innerHTML = h.pics
    .map(
      (_, k) =>
        `<span class="sv-bar${k < cur.pic ? ' done' : k === cur.pic ? ' active' : ''}"><i></i></span>`,
    )
    .join('');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const activeI = progress.querySelector('.sv-bar.active i');
  if (activeI && !reduced) {
    activeI.style.transition = 'none';
    activeI.style.width = '0%';
    // force reflow so the next transition starts from 0
    void activeI.offsetWidth;
    activeI.style.transition = `width ${STORY_DURATION}ms linear`;
    activeI.style.width = '100%';
  } else if (activeI && reduced) {
    activeI.style.width = '100%';
  }

  clearTimeout(advanceTimer);
  advanceTimer = setTimeout(nextStory, STORY_DURATION);
}

function nextStory() {
  const featured = getFeatured();
  const h = featured[cur.hotel];
  if (!h) return closeViewer();

  if (cur.pic < h.pics.length - 1) {
    cur.pic++;
  } else if (cur.hotel < featured.length - 1) {
    cur.hotel++;
    cur.pic = 0;
  } else {
    return closeViewer();
  }
  renderStory();
}

function prevStory() {
  if (cur.pic > 0) {
    cur.pic--;
  } else if (cur.hotel > 0) {
    cur.hotel--;
    const featured = getFeatured();
    cur.pic = featured[cur.hotel].pics.length - 1;
  } else {
    cur.pic = 0; // stay on the very first photo
  }
  renderStory();
}
